import React from "react";
import outOfStockIcon from "../../../../assets/out-of-stock-icon.svg";

const NoMoreQuantity = ({ isOpen, onClose}) => {
  if (!isOpen[0]) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="out-of-stock-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-icon">
          <img src={outOfStockIcon} alt="Out of Stock" />
        </div>
        
        <h2 className="modal-title">No more quantity available.</h2>
        <p className="modal-message">
          Only {isOpen[1]} units available in stock for {isOpen[2]}
        </p>
        <button className="modal-ok-btn" onClick={onClose}>
          Ok
        </button>
      </div>
    </div>
  );
};

export default NoMoreQuantity;
